<template>
  <v-card elevation="5">
    <v-card-title class="pb-0"> 篩選條件</v-card-title>
    <v-form v-model="valid" ref="form">
      <v-container class="py-0">
        <v-row>
          <!-- 時間區間 -->
          <v-col cols="12" md="4">
            <v-card-subtitle>
              時間區間
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" size="18"
                  >mdi-help-circle-outline
                  </v-icon
                  >
                </template>
                <span
                >因資料運算需要兩天的時間，所以日期都會從前天開始選取
                </span>
              </v-tooltip>
              <v-radio-group v-model="radioValue">
                <v-radio
                    v-for="item in timeInterval"
                    :value="item.value"
                    :key="item.index"
                    :label="`${item.title}`"
                    @click="recentDate(item.value)"
                    name="radioGroup"
                    class="py-1"
                ></v-radio>
                <v-radio name="radioGroup" @click="recentDate(0)">
                  <template v-slot:label>
                    <v-menu
                        ref="dateMenu"
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        min-width="290px"
                        offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateRangeText"
                            @click="datepickerClick(), recentDate(0)"
                            :rules="datePickerRule"
                            v-bind="attrs"
                            v-on="on"
                            readonly
                            dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="calendar"
                          picker-date.sync
                          :max="getDateRange(`maxDate`)"
                          :min="getDateRange(`minDate`)"
                          no-title
                          range
                          scrollable
                          show-current="false"
                      >
                        <v-spacer></v-spacer>

                        <v-btn
                            text
                            color="primary"
                            @click="$refs.dateMenu.save(calendar)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker
                      >
                    </v-menu>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-subtitle>
          </v-col>

          <!-- 來源 -->
          <v-col cols="12" md="4">
            <v-card-subtitle>
              來源
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" size="18"
                  >mdi-help-circle-outline
                  </v-icon
                  >
                </template>
                <span
                >來源最多選擇兩項
                </span>
              </v-tooltip>
              <v-select
                  v-model="sources"
                  :rules="[rules.lengthRule]"
                  :items="selectItems"
                  item-text="name"
                  item-value="source"
                  multiple chips
                  deletable-chips
              ></v-select>
            </v-card-subtitle>
          </v-col>

          <!-- 到訪者 -->
          <v-col cols="12" md="4">
            <v-card-subtitle justify="space-around">
              到訪者
              <v-row>
                <v-col cols="6">
                  <v-checkbox
                      v-model="visitors"
                      :label="`訪客`"
                      :rules="[rules.lengthRule]"
                      value="0"
                  ></v-checkbox>
                </v-col>

                <v-col cols="6">
                  <v-checkbox
                      v-model="visitors"
                      :label="`會員`"
                      :rules="[rules.lengthRule]"
                      value="1"
                      hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-subtitle>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-card-actions class="justify-space-around flex-wrap">
      <v-btn @click="search" :loading="loading">搜尋</v-btn>
    </v-card-actions>
    <v-card-actions class="justify-space-around flex-wrap">
      <v-btn elevation="2" @click="getFileInfo()">{{ chartInfoState ? "下載資料" : "取得資料" }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import swal from "sweetalert2";
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";
import {array, boolean} from "joi";
import highcharts from "highcharts";

export default {
  props: {
    chartInfoState: Boolean,
    chartInfo: Array
  },
  name: "overviewFilter",
  //Watch監聽
  watch: {
    //監聽v-model sources
    sources(chosenValue) {
      //option選擇的資料長度大於1時觸發
      if (chosenValue.length > 1) {
        for (let i = 0; i < this.selectItems.length; i++) {
          //將選擇的第一個選項的Disabled設為False
          if (chosenValue[0] == this.selectItems[i].source) {
            this.selectItems[i].disabled = false
          }
          //將選擇的第二個選項的Disabled設為False
          else if (chosenValue[1] == this.selectItems[i].source) {
            this.selectItems[i].disabled = false
          }
          //將其他選項的Disabled設為True
          else {
            this.selectItems[i].disabled = true
          }
        }
      } else {
        //將所有選項的Disabled設為False
        for (let i = 0; i < this.selectItems.length; i++) {
          this.selectItems[i].disabled = false
        }
      }
    },
    //將API的Value給到Data內的selectItems
    getAPISources(value) {
      this.selectItems = value
    },

    chartInfoState(value) {
      // this.#$emit("changechartInfoState",!this.chartInfoState);
    }
  },
  created() {
    this.initState("overview");

  },
  methods: {
    ...mapActions("overview", ["setOriginData"]),
    ...mapActions("filter", [
      "initState",
      "searchOverviewData",
      "recentDate",
      "customizedDate",
    ]),
    async search() {
      try {
        // 防止重複送出
        if (this.loading) return;
        // 表單驗證
        if (this.$refs.form.validate()) {
          this.loading = true;
          await this.searchOverviewData();
          this.loading = false;
        }
      } catch (err) {
        console.log(`${err.name}: ${err.message}`);
        swal.fire({
          title: "Oops...",
          text: "網路連線異常，請確認網路連線後再嘗試",
          icon: "error",
          width: "20rem",
        });
        this.loading = false;
      }
    },
    datepickerClick() {
      return (this.radioValue = 4);
    },
    getFileInfo() {
      if (this.chartInfoState === true) {
        this.exportCharts(this.chartInfo, {
          type: 'application/pdf',
          filename: '總覽'
        });
      }
      this.$emit("changechartInfoState", !this.chartInfoState);
    },
    exportCharts(chartInfoList, options) {
      let svgInfoList = []
      let titleList = [];
      svgInfoList = this.getSvgInfoList(chartInfoList);
      titleList = this.getFromPageTitle(chartInfoList);
      // Merge the options
      options = highcharts.merge(highcharts.getOptions().exporting, options);
      // Post to export server
      highcharts.post(options.url, {
        filename: options.filename || 'chart',
        type: options.type,
        width: options.width,
        svg: this.getSVG(svgInfoList, titleList)
      });
    },
    // 取得圖檔
    getSVG(charts, titleList) {
      // let chartList = [], topHeight = 0;
      // let titleInitX = 10, titleInitY = 40, titleInitPx = 12;
      // 設定首頁標題格式
      // let titleMap = this.getFromPageTitleMap(titleList);
      //
      // // 放入文字
      // for (let value of titleMap.values()) {
      //   chartList.push(this.setMessage(titleInitX, titleInitY + offset, titleInitPx, value.substring(0, 50)));
      //   chartList.push(this.setMessage(titleInitX, titleInitY + titleInitPx + offset, titleInitPx, value.substring(50)));
      //   offset += 28;
      // }
      // charts.forEach(chart => {
      //   let height = this.getChartHeight(chart);
      //   chartList.push(this.chartToBlock(chart, 0, topHeight + textRangeY));
      //   topHeight += height + textRangeY;
      // });
      // // ?height為1720時會自動下一頁
      // return this.mergeChartBlock(topHeight, this.getMaxChartWidth(charts), chartList);

      let chartList = [], topHeight = 0;
      let titleInitX = 100, titleInitY = 40, titleInitPx = 12, lineSize = 55;
      let offset = 0;
      let textRangeY = 90;
      let blockList = [];

      for (let i = 0; i < charts.length; i++) {
        let height = this.getChartHeight(charts[i]);
        if (i === 0) {
          // 設定首頁標題格式
          let titleMap = this.getFromPageTitleMap(titleList);
          // 放入文字
          for (let value of titleMap.values()) {
            chartList.push(this.setMessage(titleInitX, titleInitY + offset, titleInitPx, value.substring(0, lineSize)));
            chartList.push(this.setMessage(titleInitX, titleInitY + titleInitPx + offset, titleInitPx, value.substring(lineSize)));
            offset += 28;
          }
        } else {
          offset = 0;
        }
        chartList.push(this.chartToBlock(charts[i], 100, topHeight + textRangeY + offset));
        topHeight += height + textRangeY;
        if (i % 2 === 1 || i === charts.length - 1) {
          blockList.push(JSON.parse(JSON.stringify(chartList)));
          chartList = [];
          topHeight = 0;
        }
      }
      return this.mergeTwoChartBlock(blockList);
    },
    getArrayAvg(set) {
      let total = 0;
      set.forEach(e => {
        total += e;
      });
      return (total / set.length).toFixed(2);
    },
    getSvgInfoList(chartInfoList) {
      let svgInfoList = [], svgInfo = {};
      chartInfoList.forEach(e => {
        if (e.id === "totalReportPageViews") {
          svgInfo = {
            titles: "",
            chart: highcharts.chart(e.id, e.data)
          };
        }
        if (e.id === "totalReportUniqueVisitors") {
          svgInfo = {
            titles: "",
            chart: highcharts.chart(e.id, e.data)
          };
        }
        if (e.id === "totalReportAvgPageViews") {
          svgInfo = {
            titles: "",
            chart: highcharts.chart(e.id, e.data)
          };
        }
        if (e.id === "totalReportAvgPageTime") {
          svgInfo = {
            titles: "",
            chart: highcharts.chart(e.id, e.data)
          };
        }
        svgInfoList.push(svgInfo);
      })
      return svgInfoList;
    },
    getFromPageTitle(chartInfoList) {
      let titleList = [];
      chartInfoList.forEach(e => {
        let title = [];
        if (e.id === "totalReportPageViews" || e.id === "totalReportUniqueVisitors") {
          if (e.data.series.length === 1) {
            title.push({
              title: e.data.title.text,
              name: e.data.series[0].name,
              message: e.data.series[0].data.reduce((a, b) => a + b, 0)
            });
          } else {
            for (let i = 1; i < e.data.series.length; i++) {
              title.push({
                title: e.data.title.text,
                name: e.data.series[i].name,
                message: e.data.series[i].data.reduce((a, b) => a + b, 0)
              });
            }
          }
        }
        if (e.id === "totalReportAvgPageViews" || e.id === "totalReportAvgPageTime") {
          if (e.data.series.length === 1) {
            title.push({
              title: e.data.title.text,
              name: e.data.series[0].name,
              message: this.getArrayAvg(e.data.series[0].data)
            });
          } else {
            for (let i = 1; i < e.data.series.length; i++) {
              title.push({
                title: e.data.title.text,
                name: e.data.series[i].name,
                message: this.getArrayAvg(e.data.series[i].data)
              });
            }
          }
        }
        titleList.push(Object.assign(title));
      })
      return titleList;
    },
    // 設定首頁標題格式
    getFromPageTitleMap(titleList) {
      let titleMap = new Map();
      const timeMessage = this.radioValue !== 4 ? `最新${this.radioValue}天` : `${this.searchTime[0]}-${this.searchTime[1]}`;
      let visitor = "";
      this.visitors.forEach(e => e === "0" ? visitor += "訪客" : visitor += "會員");
      titleList.forEach(sourceList => {
        sourceList.forEach(source => {
          if (titleMap.has(source.name) === false) {
            titleMap.set(source.name, timeMessage + " " + source.name + "的" + visitor + " ");
          }
          if (source.title === "網頁瀏覽數" || source.title === "不重複瀏覽人數") {
            titleMap.set(source.name, titleMap.get(source.name) + source.title + ":" + this.separator(source.message) + "人 ")
          } else {
            titleMap.set(source.name, titleMap.get(source.name) + source.title + ":" + this.separator(source.message) + "秒 ")
          }
        })
      });
      return titleMap;
    },
    separator(numb) {
      const str = numb.toString().split(".");
      str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return str.join(".");
    },
  },
  computed: {
    ...mapGetters("filter", [
      "getCustomizedDate",
      "getDateRange",
      "getAPISources",
      "getAPITags",
    ]),
    ...mapFields("filter", [
      "overview.radioValue",
      "overview.sources",
      "overview.tag",
      "overview.visitors",
    ]),
    optionLoaded() {
      return this.getAPISources.length === 0;
    },
    calendar: {
      get() {
        return this.getCustomizedDate;
      },
      set(dates) {
        dates = dates.sort((a, b) => Date.parse(a) - Date.parse(b));
        this.searchTime = dates;
        this.customizedDate({date: dates});
      },
    },
    dateRangeText() {
      const dateArray = [...this.calendar];
      return dateArray.join(" ~ ").replace(/-/g, "/");
    },
    datePickerRule() {
      //選中自定義日期才需要驗證
      return this.radioValue == 4 && !this.dateMenu
          ? this.rules.datepickerRule
          : [];
    },
  },
  data: () => ({
    searchTime: [],
    selectItems: [],
    valid: false,
    loading: false,
    dateMenu: false,
    rules: {
      lengthRule: (v) => (v && v.length > 0) || "請至少選擇一項",
      datepickerRule: [
        (v) => (v && v.length > 20) || "請選擇起始日與結束日",
        (v) =>
            (v && new Set(v.split(" ~ ")).size !== 1) || "起始日不得與結束日相同",
      ],
    },
    timeInterval: [
      {title: "最新 7 天", value: 7},
      {title: "最新 15 天", value: 15},
      {title: "最新 30 天", value: 30},
      {title: "最新 60 天", value: 60},
    ],
  }),
};
</script>

